import { render, staticRenderFns } from "./ExportTransfers.vue?vue&type=template&id=b79b1974&scoped=true&"
import script from "./ExportTransfers.vue?vue&type=script&lang=js&"
export * from "./ExportTransfers.vue?vue&type=script&lang=js&"
import style0 from "./ExportTransfers.vue?vue&type=style&index=0&id=b79b1974&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b79b1974",
  null
  
)

export default component.exports